import { Element } from '../../../../common/html/element'
import { SCREEN } from '../../../../common/selectCurrencyUnit/constant'
import { useFormatCurrency } from '../../../../common/selectCurrencyUnit/useFormatCurrency'
import { formatText } from '../../../../helpers/value'
import { getCellStyle } from './helper'

export const TdCell = ({ data, colId }) => {
  const isRatioNameCell = colId.startsWith('RatioName')
  const year = isRatioNameCell ? colId.split('-')[1] : colId

  const { formatCurrency } = useFormatCurrency(SCREEN.FINANCIAL_STATEMENT)

  if (!data[year]) return null

  const renderContent = () => {
    if (isRatioNameCell) {
      return formatText(data[year]?.ratioName)
    }

    return formatCurrency({
      value: data[year]?.value,
      year,
      exchangeRateType: data[year]?.exchangeRateType,
      isFinancialStatement: true,
    })
  }

  return (
    <Element style={getCellStyle(data[year]?.fieldStyle, isRatioNameCell)}>
      {renderContent()}
    </Element>
  )
}
